import React from 'react';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { HosForms } from 'src/components/HosForms';
import { getHosLog } from '../store';

export const HosFormsTab = () => {
  const selectedHosLog = useSelector(getHosLog);

  const powerUnitNumbers = get(
    selectedHosLog,
    'metaInformation.assetInformation.powerUnitNumbers',
    [],
  );
  const trailerNumber = get(selectedHosLog, 'metaInformation.assetInformation.trailerNumbers', []);
  const shipNumber = get(selectedHosLog, 'metaInformation.shippingNumbers', []);
  const milesDriven = get(selectedHosLog, 'metaInformation.milesDriven');
  const coDriver = get(selectedHosLog, 'metaInformation.coDriver');
  const adNotes = get(selectedHosLog, 'metaInformation.additionalNotes');
  const odometer = get(selectedHosLog, 'metaInformation.odometer');
  const powerUnits = get(selectedHosLog, 'metaInformation.powerUnits', []);

  return (
    <HosForms
      powerUnitNumbers={powerUnitNumbers}
      trailerNumbers={trailerNumber}
      shipNumbers={shipNumber}
      milesDriven={milesDriven}
      coDriver={coDriver}
      adNotes={adNotes}
      certifiedStatus={selectedHosLog.certifiedStatus}
      odometer={odometer}
      powerUnits={powerUnits}
    />
  );
};
